import { useEffect, useRef } from 'react';

import { useWidgetSitePanelCtx } from '@/components';
import {
  RegisterWidgetSitePanelSave,
  WidgetSitePanelSaveHandler,
} from '@/components/widgetConfigSiteTabbedShell/widgetConfigSiteTabbedShell/widgetConfigSiteTabbedShell.types.ts';

/** Registers the panel save handler for the active site tab's footer Save button. */
export const useRegisterWidgetSitePanelSave = (save: WidgetSitePanelSaveHandler) => {
  const { registerSave } = useWidgetSitePanelCtx();
  useRegisterPanelSaveEffect(registerSave, save);
};
const useRegisterPanelSaveEffect = (
  registerSave: RegisterWidgetSitePanelSave | undefined,
  save: WidgetSitePanelSaveHandler
) => {
  const saveRef = useRef(save);
  saveRef.current = save;

  useEffect(() => {
    if (!registerSave) return;
    return registerSave(() => saveRef.current());
  }, [registerSave]);
};
